
<div class="gcontainer bwhite">
  <div class="mat-table-wrapper no-print">

    <div class="top-bar no-print">
      <table class="project-header">
        <tr>
          <td class="label">Reference</td>
          <td class="data">{{ projectReference ?? '' }}</td>
          <td class="label">Project</td>
          <td class="data" colspan="2">{{ projectName }}</td>
          <td class="label">Company</td>
          <td class="data" colspan="2">{{ companyName }}</td>
        </tr>
        <tr>
          <td class="label">Due Date</td>
          <td class="data">{{ dueDate }}</td>
          <td class="label">Oven Date</td>
          <td class="data" colspan="5">{{ ovenDate }}</td>
        </tr>
        <tr>
          <td class="label">Data</td>
          <td class="data rush-cell" colspan="7">
            @if (isRush) {
              <span>RUSH</span>
            }
          </td>
        </tr>
      </table>

      <button mat-raised-button color="warn" class="action-button" (click)="printTable()">PRINT</button>
    </div>

    <div class="mc-input-container">
      <span class="mc-label">Moisture Configuration</span>
      <input matInput class="table-input" type="number" [(ngModel)]="mcValues[0]" (ngModelChange)="buildTargetWeightsTable()" min="0" step="0.1">
      <input matInput class="table-input" type="number" [(ngModel)]="mcValues[1]" (ngModelChange)="buildTargetWeightsTable()" min="0" step="0.1">
      <input matInput class="table-input" type="number" [(ngModel)]="mcValues[2]" (ngModelChange)="buildTargetWeightsTable()" min="0" step="0.1">
      <input matInput class="table-input" type="number" [(ngModel)]="mcValues[3]" (ngModelChange)="buildTargetWeightsTable()" min="0" step="0.1">
    </div>
    <table mat-table [dataSource]="dataSource" class="full-width bordered-table">
      <ng-container matColumnDef="sampleId">
        <th mat-header-cell *matHeaderCellDef>Sample ID</th>
        <td mat-cell *matCellDef="let row">{{ row.sampleId }}</td>
      </ng-container>

      <ng-container matColumnDef="inHouseId">
        <th mat-header-cell *matHeaderCellDef>In-House ID</th>
        <td mat-cell *matCellDef="let row">{{ row.inHouseId }}</td>
      </ng-container>

      <!-- 1 -->
      <ng-container matColumnDef="targetMc1">
        <th mat-header-cell *matHeaderCellDef class="group-gray">MC 1</th>
        <td mat-cell *matCellDef="let row" class="group-gray">{{row.targetMc1}}</td>
      </ng-container>

      <ng-container matColumnDef="targetWeight1">
        <th mat-header-cell *matHeaderCellDef class="group-gray">TW 1</th>
        <td mat-cell *matCellDef="let row" class="group-gray">{{row.targetWeight1}}</td>
      </ng-container>

      <ng-container matColumnDef="actualWeight1">
        <th mat-header-cell *matHeaderCellDef class="group-gray">AW 1</th>
        <td mat-cell *matCellDef="let row" class="group-gray">{{row.actualWeight1}}</td>
      </ng-container>

      <ng-container matColumnDef="tr1">
        <th mat-header-cell *matHeaderCellDef class="group-gray">TR 1</th>
        <td mat-cell *matCellDef="let row" class="group-gray">{{row.tr1}}</td>
      </ng-container>

      <!-- 2 -->
      @if (mcValues[0] !== null) {
        <ng-container matColumnDef="targetMc2">
          <th mat-header-cell *matHeaderCellDef class="group-white">MC 2</th>
          <td mat-cell *matCellDef="let row" class="group-white">{{row.targetMc2}}</td>
        </ng-container>
      }

      @if (mcValues[0] !== null) {
        <ng-container matColumnDef="targetWeight2">
          <th mat-header-cell *matHeaderCellDef class="group-white">TW 2</th>
          <td mat-cell *matCellDef="let row" class="group-white">{{row.targetWeight2}}</td>
        </ng-container>
      }

      @if (mcValues[0] !== null) {
        <ng-container matColumnDef="actualWeight2">
          <th mat-header-cell *matHeaderCellDef class="group-white">AW 2</th>
          <td mat-cell *matCellDef="let row" class="group-white">{{row.actualWeight2}}</td>
        </ng-container>
      }

      <!-- 3-->
      @if (mcValues[1] !== null) {
        <ng-container matColumnDef="targetMc3">
          <th mat-header-cell *matHeaderCellDef class="group-gray">MC 3</th>
          <td mat-cell *matCellDef="let row" class="group-gray">{{row.targetMc3}}</td>
        </ng-container>
      }

      @if (mcValues[1] !== null) {
        <ng-container matColumnDef="targetWeight3">
          <th mat-header-cell *matHeaderCellDef class="group-gray">TW 3</th>
          <td mat-cell *matCellDef="let row" class="group-gray">{{row.targetWeight3}}</td>
        </ng-container>
      }

      @if (mcValues[1] !== null) {
        <ng-container matColumnDef="actualWeight3">
          <th mat-header-cell *matHeaderCellDef class="group-gray">AW 3</th>
          <td mat-cell *matCellDef="let row" class="group-gray">{{row.actualWeight3}}</td>
        </ng-container>
      }


      <!-- 4 -->
      @if (mcValues[2] !== null) {
        <ng-container matColumnDef="targetMc4">
          <th mat-header-cell *matHeaderCellDef class="group-white">MC 4</th>
          <td mat-cell *matCellDef="let row" class="group-white">{{row.targetMc4}}</td>
        </ng-container>
      }

      @if (mcValues[2] !== null) {
        <ng-container matColumnDef="targetWeight4">
          <th mat-header-cell *matHeaderCellDef class="group-white">TW 4</th>
          <td mat-cell *matCellDef="let row" class="group-white">{{row.targetWeight4}}</td>
        </ng-container>
      }

      @if (mcValues[2] !== null) {
        <ng-container matColumnDef="actualWeight4">
          <th mat-header-cell *matHeaderCellDef class="group-white">AW 4</th>
          <td mat-cell *matCellDef="let row" class="group-white">{{row.actualWeight4}}</td>
        </ng-container>
      }

      <!-- 5 -->
      @if (mcValues[3] !== null) {
        <ng-container matColumnDef="targetMc5">
          <th mat-header-cell *matHeaderCellDef class="group-gray">MC 5</th>
          <td mat-cell *matCellDef="let row" class="group-gray">{{row.targetMc5}}</td>
        </ng-container>
      }

      @if (mcValues[3] !== null) {
        <ng-container matColumnDef="targetWeight5">
          <th mat-header-cell *matHeaderCellDef class="group-gray">TW 5</th>
          <td mat-cell *matCellDef="let row" class="group-gray">{{row.targetWeight5}}</td>
        </ng-container>
      }

      @if (mcValues[3] !== null) {
        <ng-container matColumnDef="actualWeight5">
          <th mat-header-cell *matHeaderCellDef class="group-gray">AW 5</th>
          <td mat-cell *matCellDef="let row" class="group-gray">{{row.actualWeight5}}</td>
        </ng-container>
      }

      <tr mat-header-row *matHeaderRowDef="getDisplayedColumns()"></tr>
      <tr mat-row *matRowDef="let row; let i = index; columns: getDisplayedColumns();"></tr>
    </table>
  </div>

  <div id="print-section">
    <table class="project-header">
      <tr>
        <td class="label">Reference</td>
        <td class="data">{{ projectReference ?? '' }}</td>

        <td class="label">Project</td>
        <td class="data" colspan="2">{{ projectName }}</td>

        <td class="label">Company</td>
        <td class="data" colspan="2">{{ companyName }}</td>
      </tr>

      <tr>
        <td class="label">Due Date</td>
        <td class="data">{{ dueDate }}</td>

        <td class="label">Oven Date</td>
        <td class="data" colspan="5">{{ ovenDate }}</td>
      </tr>

      <tr>
        <td class="label">Data</td>
        <td class="data rush-cell" colspan="7">
          @if (isRush) {
            <span>RUSH</span>
          }
        </td>
      </tr>
    </table>

    <table class="print-table">
      <thead>
        <tr>
          <th>Sample ID</th>
          <th>In-House ID</th>

          <!-- MC 1 -->
          <ng-container>
            <th>MC1</th>
            <th>TW1</th>
            <th>AW1</th>
            <th>TR1</th>
          </ng-container>

          <!-- MC 2 -->
          @if (mcValues[0] !== null) {
            <th>MC2</th>
            <th>TW2</th>
            <th>AW2</th>
          }

          <!-- MC 3 -->
          @if (mcValues[1] !== null) {
            <th>MC3</th>
            <th>TW3</th>
            <th>AW3</th>
          }

          <!-- MC 4 -->
          @if (mcValues[2] !== null) {
            <th>MC4</th>
            <th>TW4</th>
            <th>AW4</th>
          }

          <!-- MC 5 -->
          @if (mcValues[3] !== null) {
            <th>MC5</th>
            <th>TW5</th>
            <th>AW5</th>
          }
        </tr>
      </thead>

      <tbody>
        @for (row of dataSource; track row) {
          <tr>
            <td>{{ row.sampleId }}</td>
            <td>{{ row.inHouseId }}</td>
            <!-- MC 1 -->
            <ng-container>
              <td>{{ row.targetMc1 }}</td>
              <td>{{ row.targetWeight1 }}</td>
              <td>{{ row.actualWeight1 }}</td>
              <td>{{ row.tr1 }}</td>
            </ng-container>
            <!-- MC 2 -->
            @if (mcValues[0] !== null) {
              <td>{{ row.targetMc2 }}</td>
              <td>{{ row.targetWeight2 }}</td>
              <td>{{ row.actualWeight2 }}</td>
            }
            <!-- MC 3 -->
            @if (mcValues[1] !== null) {
              <td>{{ row.targetMc3 }}</td>
              <td>{{ row.targetWeight3 }}</td>
              <td>{{ row.actualWeight3 }}</td>
            }
            <!-- MC 4 -->
            @if (mcValues[2] !== null) {
              <td>{{ row.targetMc4 }}</td>
              <td>{{ row.targetWeight4 }}</td>
              <td>{{ row.actualWeight4 }}</td>
            }
            <!-- MC 5 -->
            @if (mcValues[3] !== null) {
              <td>{{ row.targetMc5 }}</td>
              <td>{{ row.targetWeight5 }}</td>
              <td>{{ row.actualWeight5 }}</td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>

</div>